import * as tslib_1 from "tslib";
import { environment } from "src/environments/environment";
import * as i0 from "@angular/core";
export class EmailEncryptionService {
    constructor() {
        this.secretKey = `${environment.secretKey}`;
    }
    xorEncryptDecrypt(text, key) {
        let result = "";
        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
            result += String.fromCharCode(charCode);
        }
        return result;
    }
    stringToBase64(str) {
        return btoa(str);
    }
    base64ToString(base64) {
        return atob(base64);
    }
    addPadding(text) {
        const randomPrefix = Math.random().toString(36).substring(2, 8);
        const randomSuffix = Math.random().toString(36).substring(2, 8);
        return randomPrefix + "|" + text + "|" + randomSuffix;
    }
    removePadding(paddedText) {
        const parts = paddedText.split("|");
        return parts.length === 3 ? parts[1] : paddedText;
    }
    encryptEmail(email) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                // Import key
                const keyBuffer = new TextEncoder().encode(this.secretKey);
                const cryptoKey = yield crypto.subtle.importKey("raw", keyBuffer, { name: "AES-GCM" }, false, ["encrypt"]);
                // Generate random IV
                const iv = crypto.getRandomValues(new Uint8Array(12));
                // Encrypt
                const encodedEmail = new TextEncoder().encode(email);
                const encrypted = yield crypto.subtle.encrypt({ name: "AES-GCM", iv: iv }, cryptoKey, encodedEmail);
                // Combine IV and encrypted data
                const combined = new Uint8Array(iv.length + encrypted.byteLength);
                combined.set(iv);
                combined.set(new Uint8Array(encrypted), iv.length);
                // Convert to base64
                return btoa(String.fromCharCode.apply(null, Array.from(combined)));
            }
            catch (error) {
                console.error("Encryption failed:", error);
                throw new Error("Failed to encrypt email");
            }
        });
    }
    decryptEmail(encryptedBase64) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                // Import key
                const keyBuffer = new TextEncoder().encode(this.secretKey);
                const cryptoKey = yield crypto.subtle.importKey("raw", keyBuffer, { name: "AES-GCM" }, false, ["decrypt"]);
                // Convert from base64
                const combined = new Uint8Array(atob(encryptedBase64)
                    .split("")
                    .map((char) => char.charCodeAt(0)));
                // Extract IV and encrypted data
                const iv = combined.slice(0, 12);
                const encryptedData = combined.slice(12);
                // Decrypt
                const decrypted = yield crypto.subtle.decrypt({ name: "AES-GCM", iv: iv }, cryptoKey, encryptedData);
                return new TextDecoder().decode(decrypted);
            }
            catch (error) {
                console.error("Decryption failed:", error);
                throw new Error("Failed to decrypt email");
            }
        });
    }
    encryptEmailSimple(email) {
        const paddedEmail = this.addPadding(email);
        const encrypted = this.xorEncryptDecrypt(paddedEmail, this.secretKey);
        return this.stringToBase64(encrypted);
    }
    decryptEmailSimple(encryptedBase64) {
        try {
            const encrypted = this.base64ToString(encryptedBase64);
            const paddedEmail = this.xorEncryptDecrypt(encrypted, this.secretKey);
            const checkEmailFormat = this.isValidEmail(this.removePadding(paddedEmail));
            if (checkEmailFormat) {
                return this.removePadding(paddedEmail);
            }
            else {
                return null;
            }
        }
        catch (error) {
            return null;
        }
    }
    isValidEmail(email) {
        const emailRegex = /^[\w.-]+@[\w.-]+\.\w{2,4}$/;
        return emailRegex.test(email);
    }
    decryptFormValue(encryptedBase64) {
        try {
            const encrypted = this.base64ToString(encryptedBase64);
            const paddedEmail = this.xorEncryptDecrypt(encrypted, this.secretKey);
            return this.removePadding(paddedEmail);
        }
        catch (error) {
            return null;
        }
    }
}
EmailEncryptionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmailEncryptionService_Factory() { return new EmailEncryptionService(); }, token: EmailEncryptionService, providedIn: "root" });
